module.exports = __webpack_public_path__ + "static/media/83.de05bd1f.webp";